<template>
  <div>
    <div class="input-group img-group">
      <div class="text-center dropzone logo">
        <input
          class="upload-file img-file-m"
          type="file"
          ref="file"
          accept="image/*"
          @change="handleFileUpload()"
        />
        <input class="upload-file img-file-m" name="logo0" style="z-index: 0" />
        <div class="addImage" v-if="!showImageUrl" style="width: 100%">
          <a class="addImageIcon btn btn-primary btn-circle">
            <i class="fa fa-plus"></i>
          </a>
          <p class="text-primary m-t-sm font14 suggestFont">
            <slot name="sizeHint"></slot>
          </p>
        </div>
        <div class="editImage" v-if="showImageUrl">
          <div class="mask-bg"></div>
          <img :src="showImageUrl" />
          <div class="icon-center">
            <span class="edit-icon">
              <i class="fa fa-pencil"></i>
            </span>
            <p class="text-primary font14 font-white editFont">{{$props.modifyLabel}}</p>
            <p class="text-primary font-white m-t-sm font14 suggestFont">
              <slot name="sizeHint"></slot>
            </p>
          </div>
        </div>
      </div>
    </div>
    <slot name="sizeError" v-if="haveSizeError">{{$t("message.Image size error") }}</slot>
    <slot name="dimensionError" v-if="haveDimensionError">{{$t("message.Dimension Error") }}</slot>
    <slot name="UploadError" v-if="haveUploadError">Upload Failed!</slot>
  </div>
</template>
<script>
/**
 * props: {
    fileUploadUrl: String,
    value: String,
    modifyLabel: { type: String, default: "Modify" },
    sizeHints: { type: String, default: "" },
    filewidth: { type: Number, default: 0 },
    fileheight: { type: Number, default: 0 },
    limit: { type: Number, default: 0 }
  },
 */
import axios from "axios";
import store from "../../store";
export default {
  name: "file-upload",
  components: {},
  data() {
    return {
      //showImageUrl: ""
      haveSizeError: false,
      haveDimensionError: false,
      haveUploadError: false
    };
  },
  props: {
    fileUploadUrl: String,
    value: String,
    modifyLabel: { type: String, default: "Modify" },
    sizeHints: { type: String, default: "" },
    filewidth: { type: Number, default: 0 },
    fileheight: { type: Number, default: 0 },
    limit: { type: Number, default: 0 },
    callback:null,
    item:{},
  },
  computed: {
    showImageUrl() {
      return this.$props.value;
    },
    showSizeHint() {
      if (this.$props.sizeHint) {
        return this.$props.sizeHints;
      }
      return `${this.$props.filewidth} x ${this.$props.fileheight}, Max ${this.$props.limit} MB.`;
    }
  },
  methods: {
    _checkFilesize(file) {
      let size = file.size;

      if (size <= this.$props.limit * 1000 * 1000) {
        return true;
      }
      return false;
    },
    async _checkImagesize(file) {
      if (this.$props.filewidth === 0 && this.$props.fileheight === 0) {
        return false;
      }
      if (file) {
        let imgsize = await new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = () => {
            window.URL.revokeObjectURL(img.src);
            resolve({ height: img.height, width: img.width });
          };
          img.onerror = reject;
          img.src = window.URL.createObjectURL(file);
        });

        let width = imgsize.width,
          height = imgsize.height;

        if (
          width !== this.$props.filewidth ||
          height !== this.$props.fileheight
        ) {
          return false;
        } else {
          return true;
        }
      }

      return false;
    },
    async handleFileUpload() {
      this.haveSizeError = false;
      this.haveDimensionError = false;
      this.haveUploadError = false;
      this.file = this.$refs.file.files[0];
      if (!(await this._checkImagesize(this.file))) {
        console.error("image size not right");
        this.haveDimensionError = true;
        return false;
      }

      if (!this._checkFilesize(this.file)) {
        console.error("file size not right");
        this.haveSizeError = true;
        return false;
      }

      let formData = new FormData();

      /*
                Add the form data we need to submit
            */
      formData.append("imageFile", this.file);
      formData.append('session', store.state.userInfo.session);
      formData.append('userId', store.state.userInfo.systemUserId);
      formData.append('lang', "en_US")

      /*
          Make the request to the POST /single-file URL
        */
      axios
        .post(this.$props.fileUploadUrl, formData)
        .then(data => {
          if (data.data.errorCode === 0) {
            this.$emit("input", data.data.result.fullName);
            //this.value = data.data.result.url;
            if(this.callback)
              this.callback(data.data.result,this.item);
          }
          this.$refs.file.value = "";
        })
        .catch(() => {
          this.$refs.file.value = "";
          this.haveUploadError = true;
        });
    }
  },
  mounted() {},
  created() {}
};
</script>
